import { render, staticRenderFns } from "./edit-protocol-dialog.vue?vue&type=template&id=cf0fb2bc&scoped=true"
import script from "./edit-protocol-dialog.vue?vue&type=script&lang=js"
export * from "./edit-protocol-dialog.vue?vue&type=script&lang=js"
import style0 from "./edit-protocol-dialog.vue?vue&type=style&index=0&id=cf0fb2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0fb2bc",
  null
  
)

export default component.exports